export const routesConstants = {
  ADD: 'ROUTES_ADD'
};
